<!-- MODAL Agregar Descuento -->
<div mdbModal #agregarDescuento="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="width: 80%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          <ng-container *ngIf="mode === 'ADD'">
            Agregar descuento
          </ng-container>
          <ng-container *ngIf="mode === 'EDIT'">
            Editar descuento
          </ng-container>
          <ng-container *ngIf="mode === 'VIEW'">
            Ver descuento
          </ng-container>
        </h4>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- Cabecera de botones -->

        <div class="d-flex flex-row" *ngIf="mode === 'VIEW'">
          <div class="waves-input-wrapper waves-light" mdbWavesEffect>
            <label mdbBtn color="primary" [(ngModel)]="currentTabs" (click)="verDetalle()" mdbRadio="detalle">
              Resumen Descuento
            </label>
          </div>
          <div class="waves-input-wrapper waves-light" mdbWavesEffect>
            <label mdbBtn color="primary" [(ngModel)]="currentTabs" (click)="verAuditoria()" mdbRadio="auditoria">
              Auditoria Descuento
            </label>
          </div>
        </div>

        <ng-container *ngIf="currentTabs === 'detalle'">
          <div class="filtros" [ngClass]="{'disabledContent': mode === 'VIEW'}">
            <form [formGroup]="formHeader">

              <div class="row" style="border-bottom: 1px solid #dee2e6;">
                <div class="col">
                  <h5 class="modal-title w-100 text-left" id="myModalLabel">
                    Datos descuento
                  </h5>
                </div>
              </div>

              <div class="row filtros-body">
                <div class="col">
                  <div class="md-form">
                    <input value="" type="text" id="descripcion" class="form-control" placeholder="" required
                      #descripcion formControlName="descripcion" />
                    <label for="descripcion">Descripción</label>
                    <div *ngIf="
                      formHeader.get('descripcion').invalid &&
                      (formHeader.get('descripcion').dirty ||
                      formHeader.get('descripcion').touched)
                    ">
                      <mdb-error *ngIf="formHeader.get('descripcion').hasError('required')">Ingrese descripción
                      </mdb-error>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6;">
                <div class="">
                  <h5 class="modal-title w-100 text-left" id="myModalLabel">
                    Seleccionar clientes
                  </h5>
                </div>
                <div></div>
              </div>
              <div class="row filtros-body">
                <div class="col">
                  <strong>Buscar por: </strong>
                  <!-- Material inline 1 -->
                  <div class="form-check form-check-inline">
                    <input type="radio" class="form-check-input" id="dctosEspeciales_modal_rbBuscarPor_cliente"
                      formControlName="buscarPor" [value]="TIPO_TIPO_CLIENTE" mdbInput />
                    <!-- (change)='limpiarBuscarPorCliente()' -->
                    <label class="form-check-label" for="dctosEspeciales_modal_rbBuscarPor_cliente">Tipo cliente</label>
                  </div>

                  <!-- Material inline 2 -->
                  <div class="form-check form-check-inline">
                    <input type="radio" class="form-check-input" id="dctosEspeciales_modal_rbBuscarPor_tipo_cliente"
                      formControlName="buscarPor" [value]="TIPO_CLIENTE" mdbInput />
                    <!-- (change)='limpiarBuscarPorTiposClientes()' -->
                    <label class="form-check-label" for="dctosEspeciales_modal_rbBuscarPor_tipo_cliente">Cliente</label>
                  </div>

                  <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                    (click)="abrirModalSeleccion()">
                    <mdb-icon fas icon="search"></mdb-icon>
                  </button>

                  <ng-container *ngIf="formHeader.get('buscarPor').value === TIPO_CLIENTE">
                    <button mdbBtn type="button" class="btn-seleccionados" color="info" mdbWavesEffect
                      [ngClass]="{'enabledContent': true}" (click)="abrirModalSeleccionarClienteSeleccionados()"
                      *ngIf="clientesSeleccionados?.length > 0">
                      ({{clientesSeleccionados.length | numerico}}) Seleccionados
                    </button>
                  </ng-container>
                  <ng-container *ngIf="formHeader.get('buscarPor').value === TIPO_TIPO_CLIENTE">
                    <button mdbBtn type="button" class="btn-seleccionados" color="info" mdbWavesEffect
                      [ngClass]="{'enabledContent': true}" (click)="abrirModalSeleccionarTiposClienteSeleccionados()"
                      *ngIf="tiposClientesSeleccionados?.length > 0">
                      ({{tiposClientesSeleccionados.length | numerico}}) Seleccionados
                    </button>
                  </ng-container>

                  <!-- <h6 class="text-info" style="cursor: pointer; pointer-events: all; opacity: 1;"
                    (click)="verClientesSeleccionados()" *ngIf="clientesSeleccionados">
                    Ver Clientes
                  </h6>
                  <h6 class="text-info" *ngIf="tiposClientesSeleccionados">
                    {{ tiposClientesSeleccionadosFormatted }}
                  </h6> -->
                  <h6 *ngIf="
                    formHeader.get('clienteOrTipos').invalid &&
                    (formHeader.get('clienteOrTipos').dirty ||
                    formHeader.get('clienteOrTipos').touched)
                  ">
                    <mdb-error *ngIf="formHeader.get('clienteOrTipos').hasError('required')">Ingrese cliente o tipo(s)
                      de
                      cliente(s)
                    </mdb-error>
                  </h6>
                </div>

                <div class="col">
                  <div class="row">
                    <div class="col" style="display: flex; align-items: center;padding-right: 0;">
                      <div class="switch info-switch">
                        <label>
                          Inactivo
                          <input type="checkbox" color="info" formControlName="activo" />
                          <span class="lever"></span> Activo
                        </label>
                      </div>
                    </div>

                    <div class="col">
                      <div class="md-form">
                        <mdb-date-picker #datePickerInicio [inline]="true" name="fechaInicio"
                          [ngClass]="{'disabledContent': mode === 'EDIT' || mode === 'VIEW'}"
                          [placeholder]="'Fecha inicio'" required formControlName='fechaInicio'>
                        </mdb-date-picker>
                        <div *ngIf="
                          formHeader.get('fechaInicio').invalid &&
                          (formHeader.get('fechaInicio').dirty ||
                          formHeader.get('fechaInicio').touched)
                        ">
                          <mdb-error *ngIf="formHeader.get('fechaInicio').hasError('required')">Ingrese fecha inicio
                          </mdb-error>
                          <!-- <mdb-error *ngIf="formHeader.get('fechaInicio').hasError('min')">Descuento máximo
                            debe ser mayor o igual a 0 </mdb-error>
                          <mdb-error *ngIf="formHeader.get('fechaInicio').hasError('max')">Descuento máximo
                            debe ser menor a 100 </mdb-error> -->
                        </div>
                      </div>
                    </div>

                    <div class="col">
                      <div class="md-form">
                        <mdb-date-picker #datePickerFinal [inline]="true" name="fechaFinal"
                          [placeholder]="'Fecha final'" required formControlName='fechaFin'>
                        </mdb-date-picker>
                        <div *ngIf="
                          formHeader.get('fechaFin').invalid &&
                          (formHeader.get('fechaFin').dirty ||
                          formHeader.get('fechaFin').touched)
                        ">
                          <mdb-error *ngIf="formHeader.get('fechaFin').hasError('required')">Ingrese fecha fin
                          </mdb-error>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <form [formGroup]='formDetails' (ngSubmit)="agregarItemDescuento()">
              <div class="row" style="border-bottom: 1px solid #dee2e6;">
                <div class="col">
                  <h5 class="modal-title w-100 text-left" id="myModalLabel">
                    Productos a descuentos
                  </h5>
                </div>
              </div>

              <div class="row filtros-body">
                <div class="col">
                  <div class="md-form">
                    <input value="" type="text" id="codigoProducto" class="form-control" placeholder="" required
                      #codigoProducto formControlName="codigoProducto" />
                    <label for="codigoProducto">Código de producto</label>
                    <div *ngIf="
                      formDetails.get('codigoProducto').invalid &&
                      (formDetails.get('codigoProducto').dirty ||
                      formDetails.get('codigoProducto').touched)
                    ">
                      <mdb-error *ngIf="formDetails.get('codigoProducto').hasError('required')">Ingrese código de
                        producto
                      </mdb-error>
                      <mdb-error *ngIf="formDetails.get('codigoProducto').hasError('min')">Código de producto debe ser
                        mayor a 0 </mdb-error>
                      <!-- <mdb-error *ngIf="formDetails.get('codigoProducto').hasError('max')">Descuento máximo
                            debe ser menor a 100 </mdb-error> -->
                    </div>
                  </div>
                </div>
                <div class="col d-flex align-items-center producto-selector">
                  <div class="d-flex align-items-center flex-nowrap producto-selector-actions">
                    <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                      (click)="abrirModalSeleccionarProducto()">
                      <mdb-icon fas icon="search"></mdb-icon>
                    </button>

                    <button mdbBtn type="button" class="btn-seleccionados" color="info" mdbWavesEffect
                      *ngIf="productosMultiplesSeleccionados?.length > 1"
                      (click)="abrirModalSeleccionarProductosSeleccionados()">
                      ({{productosMultiplesSeleccionados.length | numerico}}) Seleccionados
                    </button>
                  </div>

                  <h6 class="text-info producto-seleccionado-nombre"
                    *ngIf="productosMultiplesSeleccionados?.length === 1">
                    {{ productosMultiplesSeleccionados[0].descripcion }}
                  </h6>
                </div>

                <div class="col">
                  <!-- *ngIf="optionsTipoDescuento?.length !== 1" -->
                  <div class="md-form">
                    <mdb-select label="Tipo de descuento" [options]="optionsTipoDescuento"
                      placeholder="Tipo de descuento" formControlName="tipoDescuento"
                      [filterEnabled]="true"></mdb-select>
                    <div *ngIf="
                      formDetails.get('tipoDescuento').invalid &&
                      (formDetails.get('tipoDescuento').dirty ||
                      formDetails.get('tipoDescuento').touched)
                    ">
                      <mdb-error *ngIf="formDetails.get('tipoDescuento').hasError('required')">Ingrese tipo de descuento
                      </mdb-error>
                    </div>
                  </div>
                </div>

                <div class="col">
                  <div class="md-form">
                    <div *ngIf="formDetails.get('tipoDescuento').value === '1'">
                      <input value="" type="text" id="montoPorcentaje" class="form-control" placeholder="Valor ($)"
                        formControlName="montoOrPorcentaje" required #montoPorcentaje monto />
                    </div>
                    <div *ngIf="formDetails.get('tipoDescuento').value === '2'">
                      <input value="" type="text" id="montoPorcentaje" class="form-control" placeholder="Valor (%)"
                        formControlName="montoOrPorcentaje" required #montoPorcentaje />
                    </div>

                    <label for="montoPorcentaje">
                      <span
                        *ngIf="formDetails.get('tipoDescuento').value !== '1' && formDetails.get('tipoDescuento').value !== '2'">Monto
                        o Porcentaje</span>
                      <span *ngIf="formDetails.get('tipoDescuento').value === '1'">Monto</span>
                      <span *ngIf="formDetails.get('tipoDescuento').value === '2'">Porcentaje</span>
                    </label>
                    <div *ngIf="
                      formDetails.get('montoOrPorcentaje').invalid &&
                      (formDetails.get('montoOrPorcentaje').dirty ||
                      formDetails.get('montoOrPorcentaje').touched)
                    ">
                      <mdb-error *ngIf="formDetails.get('montoOrPorcentaje').hasError('required')">Ingrese monto o
                        porcentaje
                      </mdb-error>
                      <mdb-error *ngIf="formDetails.get('montoOrPorcentaje').hasError('min')">Monto o porcentaje debe
                        ser
                        mayor a 0 </mdb-error>
                      <mdb-error *ngIf="formDetails.get('montoOrPorcentaje').hasError('descuentoInvalido')"> El
                        descuento
                        no puede tener más de dos decimales.
                      </mdb-error>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row card-footer text-muted filtros-footer" style="
                border-top: 1px solid #dee2e6;
                border-bottom: 1px solid #dee2e6;
              ">
                <div></div>
                <!-- [disabled]="!productoSeleccionado" -->
                <button mdbBtn type="submit" color="indigo" mdbWavesEffect>
                  Agregar
                </button>
              </div>
            </form>
          </div>

          <div class="table-responsive" style="margin-top: 20px;" *ngIf="listaDescuentosPage.length > 0">
            <table class="table table-striped table-hover table-sm align-middle">
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col">Código</th>
                  <th scope="col">Descripción</th>
                  <th scope="col">Precio</th>
                  <th scope="col">Descuento</th>
                  <th scope="col">Precio Final</th>

                  <!-- <th scope="col">Tipo de descuento</th> -->
                  <th scope="col">Monto/Porcentaje</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dcto of listaDescuentosPage; let i = index; trackBy: trackByDetalleProductoCodigo">
                  <td>{{ dcto.sku }}</td>
                  <td>{{ dcto.descripcion }}</td>
                  <td>$ {{dcto.precio_unitario | number}}</td>
                  <td>$ {{dcto.descuento | number }}</td>
                  <td>$ {{dcto.precioFinal | number}}</td>

                  <!-- <td>{{ dcto.tipoDescuentoGlosa }}</td> -->
                  <td *ngIf="dcto.tipoDescuento === '1'">
                    <div class="m-0 row">
                      <div class="col-1">
                        <span>$</span>

                      </div>
                      <div class="col-3">
                        <input value="dcto.monto" type="text" class="form-control" required min="1"
                          [(ngModel)]="dcto.monto" name="descuento" #descuento="ngModel" [readonly]=""
                          [disabled]="i != inputLinea" monto />
                      </div>

                    </div>
                    <div>
                      <mdb-error style="position: static;" *ngIf="dcto.monto === ''">
                        Descuento no válido
                      </mdb-error>
                    </div>
                    <!-- $ {{ dcto.monto | numerico }} -->
                  </td>
                  <td *ngIf="dcto.tipoDescuento === '2'">
                    <div class="m-0 row">
                      <div class="col-1">
                        <span>%</span>

                      </div>
                      <div class="col-3">
                        <input value="dcto.porcentaje" type="text" class="form-control" required min="1"
                          [(ngModel)]="dcto.porcentaje" name="descuento" #descuento="ngModel" [readonly]=""
                          [disabled]="i != inputLinea" />
                      </div>

                    </div>
                    <div>
                      <mdb-error style="position: static;" *ngIf="dcto.porcentaje === ''">
                        Descuento no válido
                      </mdb-error>
                    </div>
                    <!-- {{ dcto.porcentaje }} % -->

                  </td>
                  <td>
                    <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                      [disabled]="mode === 'VIEW'" (click)="eliminarItemDescuento(dcto.index)">
                      <mdb-icon fas icon="trash"></mdb-icon>
                    </button>
                    <button [disabled]="mode === 'VIEW'" class="btn-actions-sm" *ngIf="i != inputLinea"
                      color="secondary" mdbBtn type="button" mdbWavesEffect (click)="EditarProducto(dcto,i)">
                      <mdb-icon fas icon="edit"></mdb-icon>
                    </button>
                    <button [disabled]="mode === 'VIEW'" *ngIf="i === inputLinea" class="btn-actions-sm" color="success"
                      mdbBtn type="button" mdbWavesEffect (click)="ProcesoEditarPedidoCompletado()">
                      <mdb-icon fas icon="check"></mdb-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
              <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"></app-pagination>
            </table>
          </div>
        </ng-container>
        <app-lista-auditoria *ngIf="currentTabs === 'auditoria'" [auditoria]="auditoria"></app-lista-auditoria>

      </div>

      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="hide()" mdbWavesEffect>
          Cerrar
        </button>
        <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect (click)="guardar()"
          [disabled]="btnGuardarDisabled === true || listaDescuentos.length == 0"
          *ngIf="mode === 'ADD' || mode === 'EDIT'">
          <div class="spinner-border spinner-border-sm" *ngIf="btnGuardarDisabled === true">
            <mdb-spinner spinnerColor="transparent"></mdb-spinner>
          </div>
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>


<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente (onSelectMultiple)="onClienteSeleccionadoMultiple($event)">
</app-modal-seleccionar-cliente>
<app-modal-seleccionar-cliente-tipos (onSelectMultiple)="onClienteTiposSeleccionado($event)">
</app-modal-seleccionar-cliente-tipos>

<!-- MODAL seleccionarProducto -->
<!-- (onRemoteQuery)="getProductsByUnidadNegocio($event)" -->
<!-- <app-modal-seleccionar-producto (onSelect)="onProductoSeleccionado($event)" [showFiltroActivoInactivo]="false"
  (onNotFound)="onProductoNoEncontrado()" showSelectAll="true" (onSelectAll)="onMultiplesProductosSeleccionados($event)"
  paginateLocally="true" (onUncheckProducto)="uncheckProducto($event)">
</app-modal-seleccionar-producto> -->


<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto [origen]="MODAL_SEL_PROD_DESCUENTO" (onSelect)="onProductoSeleccionado($event)"
  [showFiltroActivoInactivo]="false" (onNotFound)="onProductoNoEncontrado()" showSelectAll="true"
  (onSelectAll)="onMultiplesProductosSeleccionados($event)" (onRemoteQuery)="getProductsByUnidadNegocio($event)"
  paginateLocally="true" (onUncheckProducto)="uncheckProducto($event)">
</app-modal-seleccionar-producto>

<app-modal-show-clientes mode="RUT_SUCURSAL">
</app-modal-show-clientes>

<app-modal-ver-errores></app-modal-ver-errores>

<app-modal-confirm title="Eliminar Producto" contentText="¿Desea eliminar el SKU seleccionado?">
</app-modal-confirm>
